import Router from '~/utils/Router'
import Meta from '~/utils/RouterMeta'

export const order = [
  Router.instance({
    path: 'order-create',
    name: 'order-create',
    component: () => import('@/pages/order/create'),
    meta: Meta.instance({
      title: 'Создать Заявку',
      btnName: 'Заявку',
      show: false,
      permissions: ['logist', 'manager', 'moderator', 'admin'],
      appendBtn: true
    })
  }),
  Router.instance({
    path: 'order-update/:id?',
    name: 'order-update',
    component: () => import('@/pages/order/update'),
    props: true,
    meta: Meta.instance({
      title: 'Заявка',
      permissions: ['logist', 'manager', 'moderator', 'admin'],
      show: false
    })
  })
]


const importersChild = [
  Router.instance({
    path: 'importers/importer',
    name: 'importers-importer',
    component: () => import('@/pages/importer/index'),
    meta: Meta.instance({
      title: 'Импортеры',
      permissions: ['admin', 'moderator']
    })
  }),

  Router.instance({
    path: 'importers/importer-create/:id?',
    props: true,
    name: 'importer-create',
    component: () => import('@/pages/importer/create'),
    meta: Meta.instance({
      title: 'Импортеры',
      show: false,
      permissions: ['admin', 'moderator']
    })
  }),
  Router.instance({
    path: 'importer-invoices',
    name: 'importer-invoices',
    component: () => import('@/pages/importer_invoice/index'),
    meta: Meta.instance({
      title: 'Инвойс',
      permissions: ['admin', 'moderator']
    })
  }),
  Router.instance({
    path: 'importer-invoice/:id?',
    name: 'importer-invoice',
    props: true,
    component: () => import('@/pages/importer_invoice/create'),
    meta: Meta.instance({
      title: 'Инвойс',
      show: false,
      permissions: ['admin', 'moderator']
    })
  }),
  Router.instance({
    path: 'importers/gdt',
    name: 'importers-gdt',
    component: () => import('@/pages/gdt/index'),
    meta: Meta.instance({
      title: 'ГТД',
      permissions: ['admin', 'moderator']
    })
  }),
  Router.instance({
    path: 'gdt/:id?',
    name: 'gdt',
    props: true,
    component: () => import('@/pages/gdt/create'),
    meta: Meta.instance({
      title: 'ГТД',
      show: false,
      permissions: ['admin', 'moderator']
    })
  }),
  Router.instance({
    path: 'importers-consignments',
    name: 'importers-consignments',
    component: () => import('@/pages/consignment/index'),
    meta: Meta.instance({
      title: 'Партия',
      permissions: ['admin', 'moderator']
    })
  }),
  Router.instance({
    path: 'importers-consignment/:id?',
    name: 'importers-consignment',
    props: true,
    component: () => import('~/pages/consignment/createOrUpdate'),
    meta: Meta.instance({
      title: 'Партия',
      permissions: ['admin', 'moderator'],
      show: false
    })
  })
]

export const importers = [
  Router.instance({
    meta: Meta.instance({
      title: 'Импортер',
      permissions: ['admin', 'moderator'],
      subGroup: true
    }),
    children: importersChild
  }),
  Router.instance({
    meta: Meta.instance({
      title: 'Поставщик',
      subGroup: true,
      permissions: ['admin', 'moderator']
    }),
    children: [
      Router.instance({
        path: 'coming-suppliers',
        name: 'coming-suppliers',
        component: () => import('@/pages/supplier/index'),
        meta: Meta.instance({
          title: 'Поставщики',
          permissions: ['admin', 'moderator']
        })
      }),
      Router.instance({
        path: 'supplier-create/:id?',
        name: 'supplier-create',
        props: true,
        component: () => import('@/pages/supplier/create'),
        meta: Meta.instance({
          title: 'Поставщики',
          show: false,
          permissions: ['admin', 'moderator']
        })
      }),
      Router.instance({
        path: 'coming-waybills',
        name: 'coming-waybills',
        component: () => import('@/pages/coming_waybill/index'),
        meta: Meta.instance({
          title: 'ТТН',
          permissions: ['admin', 'moderator']
        })
      }),
      Router.instance({
        path: 'coming-waybill/:id?',
        name: 'coming-waybill',
        props: true,
        component: () => import('@/pages/coming_waybill/create'),
        meta: Meta.instance({
          title: 'ТТН',
          show: false,
          permissions: ['admin', 'moderator']
        })
      }),
      Router.instance({
        path: 'coming-empowerments',
        name: 'coming-empowerments',
        props: true,
        component: () => import('@/pages/coming_empowerment/index'),
        meta: Meta.instance({
          title: 'Доверенность',
          permissions: ['admin', 'moderator']
        })
      }),
      Router.instance({
        path: 'coming-empowerment/:id?',
        name: 'coming-empowerment',
        props: true,
        component: () => import('@/pages/coming_empowerment/create'),
        meta: Meta.instance({
          title: 'Доверенность',
          show: false,
          permissions: ['admin', 'moderator']
        })
      }),
      Router.instance({
        path: 'coming-invoices',
        name: 'coming-invoices',
        component: () => import('@/pages/coming_invoice/index'),
        meta: Meta.instance({
          title: 'Счет фактуры',
          permissions: ['admin', 'moderator']
        })
      }),
      Router.instance({
        path: 'coming-invoice/:id?',
        props: true,
        name: 'coming-invoice',
        component: () => import('@/pages/coming_invoice/create'),
        meta: Meta.instance({
          title: 'Счет фактуры',
          show: false,
          permissions: ['admin', 'moderator']
        })
      }),
      Router.instance({
        path: 'consignments-supply',
        name: 'consignments-supply',
        component: () => import('@/pages/consignment_supply/index'),
        meta: Meta.instance({
          title: 'Партия',
          permissions: ['admin', 'moderator']
        }),
      }),
        Router.instance({
          path: 'consignment-supply/:id?',
          name: 'consignment-supply',
          props: true,
          component: () => import('@/pages/consignment_supply/createOrUpdate'),
          meta: Meta.instance({
            title: 'Партия',
            show: false,
            permissions: ['admin', 'moderator']
          })
      })
    ]
  }),
  Router.instance({
    meta: Meta.instance({
      title: 'ПЛАТЕЖИ',
      subGroup: true,
      permissions: ['admin']
    }),
    children: [
      Router.instance({
        path: 'coming-payment-importers',
        name: 'coming-payment-importers',
        component: () => import('@/pages/coming_payment_importer/index'),
        meta: Meta.instance({
          title: 'Импортеры',
          permissions: ['admin']
        })
      }),
      Router.instance({
        path: 'coming-payment-importer/:id?',
        props: true,
        name: 'coming-payment-importer',
        component: () => import('@/pages/coming_payment_importer/create'),
        meta: Meta.instance({
          title: 'Импортер',
          show: false,
          permissions: ['admin']
        })
      }),
      Router.instance({
        path: 'coming-payment-suppliers',
        name: 'coming-payment-suppliers',
        component: () => import('@/pages/coming_payment_supplier/index'),
        meta: Meta.instance({
          title: 'Поставщики',
          permissions: ['admin']
        })
      }),
      Router.instance({
        path: 'coming-payment-supplier/:id?',
        props: true,
        name: 'coming-payment-supplier',
        component: () => import('@/pages/coming_payment_supplier/create'),
        meta: Meta.instance({
          title: 'Поставщики',
          show: false,
          permissions: ['admin']
        })
      })
    ]
  })
]


export const company = [
  Router.instance({
    path: 'company/:id?',
    name: 'company',
    props: true,
    component: () => import('@/pages/company/createOrUpdate'),
    meta: Meta.instance({
      title: 'Покупатель',
      show: false,
      permissions: ['manager', 'buhgalter', 'moderator', 'admin']
    })
  }),
  Router.instance({
    path: 'company-create',
    name: 'company-create',
    props: true,
    component: () => import('@/pages/company/createOrUpdate'),
    meta: Meta.instance({
      title: 'Создать покупателя',
      btnName: 'Покупателя',
      show: false,
      appendBtn: true,
      permissions: ['manager', 'buhgalter', 'moderator', 'admin']
    })
  })
]

export const contract = [
  Router.instance({
    path: 'contract/:id?',
    name: 'contract-show',
    props: true,
    component: () => import('@/pages/contract/create'),
    meta: Meta.instance({
      title: 'Контракт',
      show: false,
      permissions: ['manager', 'buhgalter', 'moderator', 'admin']
    })
  }),
  Router.instance({
    path: 'contract-create',
    name: 'contract-create',
    component: () => import('@/pages/contract/create'),
    meta: Meta.instance({
      title: 'Создать контракт',
      btnName: 'Контракт',
      show: false,
      appendBtn: true,
      permissions: ['manager', 'buhgalter', 'moderator', 'admin']
    })
  }),
  Router.instance({
    path: 'additional-contract-create/:contractId?',
    name: 'additional-contract-create',
    props: true,
    component: () => import('@/pages/additional_contract/test.vue'),
    meta: Meta.instance({
      title: 'Создать дополнительный контракт',
      show: false,
      permissions: ['manager', 'buhgalter', 'moderator', 'admin']
    })
  }),
  Router.instance({
    path: 'additional-contract-show/:id',
    name: 'additional-contract-show',
    props: true,
    component: () => import('@/pages/additional_contract/test.vue'),
    meta: Meta.instance({
      title: 'Создать дополнительный контракт',
      show: false,
      permissions: ['manager', 'buhgalter', 'moderator', 'admin']
    })
  })
]

export const waybill = [
  Router.instance({
    path: 'waybill-create',
    name: 'waybill-create',
    component: () => import('@/pages/waybill/create'),
    meta: Meta.instance({
      title: 'Создать ТТН',
      btnName: 'ТТН',
      appendBtn: true,
      show: false,
      permissions: ['manager', 'buhgalter', 'moderator', 'admin']
    })
  }),
  Router.instance({
    path: 'waybill-update/:id',
    name: 'waybill-update',
    component: () => import('@/pages/waybill/update'),
    props: true,
    meta: Meta.instance({
      title: 'Показать ТТН',
      show: false,
      permissions: ['manager', 'buhgalter', 'moderator', 'admin']
    })
  }),
  Router.instance({
    path: 'order-from-waybill/:orderId',
    name: 'order-from',
    props: true,
    component: () => import('@/pages/waybill/create-order'),
    meta: Meta.instance({
      title: 'Создать ТТН',
      show: false,
      permissions: ['manager', 'buhgalter', 'moderator', 'admin']
    })
  })
]

export const empowerment = [
  Router.instance({
    path: 'procuration/:id?',
    name: 'procuration-show',
    component: () => import('@/pages/empowerment/create.vue'),
    props: true,
    meta: Meta.instance({
      title: 'Показать доверенность',
      show: false,
      permissions: ['manager', 'buhgalter', 'moderator', 'admin']
    })
  }),
  Router.instance({
    path: 'procuration-create',
    name: 'procuration-create',
    component: () => import('@/pages/empowerment/create.vue'),
    meta: Meta.instance({
      title: 'Создать доверенность',
      btnName: 'Доверенность',
      appendBtn: true,
      show: false,
      permissions: ['manager', 'buhgalter', 'moderator', 'admin']
    })
  })
]

export const invoice = [
  Router.instance({
    path: 'invoice/:id?',
    name: 'invoice',
    component: () => import('@/pages/invoice/update'),
    props: true,
    meta: Meta.instance({
      title: 'Показать счёт фактуру',
      btnName: 'Счёт фактуру',
      appendBtn: true,
      show: false,
      permissions: ['manager', 'buhgalter', 'moderator', 'admin']
    })
  })
]

export const act = [
  Router.instance({
    path: 'act/:id?',
    name: 'act',
    component: () => import('@/pages/act/create'),
    props: true,
    meta: Meta.instance({
      title: 'АКТ сверки',
      btnName: 'АКТ',
      appendBtn: true,
      show: false,
      permissions: ['manager', 'buhgalter', 'moderator', 'admin']
    })
  })
]

export const payment = [
  Router.instance({
    path: 'payment/:id?',
    name: 'payment',
    props: true,
    component: () => import('@/pages/payment/create'),
    meta: Meta.instance({
      title: 'ПЛАТЕЖ',
      btnName: 'ПЛАТЕЖ',
      appendBtn: true,
      show: false,
      permissions: ['manager', 'buhgalter', 'moderator', 'admin']
    })
  })
]

export const user = [
  Router.instance({
    path: 'users',
    name: 'users',
    component: () => import('@/pages/user/index'),
    meta: Meta.instance({
      title: 'Пользователи',
      show: false,
      permissions: ['admin']
    })
  }),
  Router.instance({
    path: 'user/:id?',
    name: 'user',
    props: true,
    component: () => import('@/pages/user/test'),
    meta: Meta.instance({
      title: 'Пользователь',
      show: false,
      permissions: ['admin']
    })
  }),
  Router.instance({
    path: 'seller/:id?',
    name: 'seller',
    props: true,
    component: () => import('@/pages/seller/createOrUpdate'),
    meta: Meta.instance({
      title: 'продавец',
      show: false,
      permissions: ['admin']
    })
  })
]
